import { VlRouteBase } from '@vuelib/components';

export default /** @type { import('vue-router').RouteConfig } */ ({
  path: 'mytransactions',
  component: VlRouteBase,
  meta: {},
  children: [
    {
      path: '',
      name: 'myTransactionList',
      component: () => import('@/views/mytransactions/index.vue'),
      meta: {
        roles: ['withoutrules', 'admin', 'developer', 'support', 'company'],
      },
    },
    {
      path: ':userId/transactions/:transactionId/metadata',
      name: 'myTransactionMetadata',
      component: () => import('@/views/myusers/transactions/metadata/index.vue'),
      meta: {
        roles: ['withoutrules', 'admin', 'developer', 'support', 'company'],
      },
    },
    {
      path: ':userId/transactions/:transactionId/metadata/:metadataId/data',
      name: 'myTransactionMetadataData',
      component: () => import('@/views/myusers/transactions/metadata/data/index.vue'),
      meta: {
        roles: ['withoutrules', 'admin', 'developer', 'support', 'company'],
      },
    },
  ],
});
